/*
 * cart-drawer-render.js
 * ---------------------------------------------------------------------------
 * ArtKarat cart drawer fix.
 *
 * Problem:
 *   luxwatches.min.js -> doUpdateDropdownCart() rebuilt the drawer from a
 *   hand-written JS string template using /cart.js data. That template has no
 *   compare-at price, no "% OFF" badge, and no discount row, and it hardcoded
 *   the money format ("Rs " + price/100 + ".00"). So after an AJAX add-to-cart
 *   the drawer was missing the offer info until a manual page refresh, at which
 *   point the Liquid in snippets/wrapper-top-cart.liquid rendered it correctly.
 *
 * Fix:
 *   Stop rebuilding the drawer in JS. After any cart mutation, ask Shopify to
 *   re-render the same Liquid the page load uses (Section Rendering API) and
 *   swap it in. One source of truth => AJAX output === refreshed output,
 *   including automatic/line-level discounts computed server side.
 *
 * Requires: sections/advance-cartdrawer.liquid (renders 'wrapper-top-cart').
 * Load AFTER luxwatches.min.js.
 */
(function () {
  'use strict';

  var SECTION_ID = 'advance-cartdrawer';
  var DRAWER_SELECTOR = '#dropdown-cart, .cstm-cart-drawer';

  var originalUpdate = null;
  var pending = null;

  /* Every drawer instance on the page (desktop + mobile headers both include
     the snippet, so there can legitimately be more than one node). */
  function eachDrawer(fn) {
    var seen = [];
    var nodes = document.querySelectorAll(DRAWER_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (seen.indexOf(nodes[i]) === -1) {
        seen.push(nodes[i]);
        fn(nodes[i]);
      }
    }
  }

  function fetchDrawerMarkup() {
    var url = '/cart?section_id=' + SECTION_ID + '&_=' + Date.now();

    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart drawer section render failed: ' + res.status);
      return res.text();
    });
  }

  function paint(markup) {
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var freshDrawer = parsed.querySelector(DRAWER_SELECTOR);
    if (!freshDrawer) throw new Error('Cart drawer not found in section markup');

    var freshList = freshDrawer.querySelector('.mini-products-list');
    var hasItems = !!(freshList && freshList.children.length);

    /* Header bag count */
    var freshCount = parsed.querySelector('[data-cart-count]');
    if (freshCount) {
      var countText = freshCount.textContent.trim();
      var counters = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < counters.length; i++) counters[i].textContent = countText;
    }

    /* Swap innerHTML of the individual blocks rather than of .has-items itself.
       luxwatches caches a jQuery reference to .mini-products-list at doc.ready
       (checkItemsInDropdownCart reads it), so that node must stay alive.
       .cart-title and .hitsy-progress-block (app block) are deliberately left
       untouched so the offer progress bar is not destroyed. */
    var PARTS = ['.mini-products-list', '.summary', '.actions'];

    eachDrawer(function (drawer) {
      for (var i = 0; i < PARTS.length; i++) {
        var target = drawer.querySelector(PARTS[i]);
        var source = freshDrawer.querySelector(PARTS[i]);
        if (target && source) target.innerHTML = source.innerHTML;
      }

      var container = drawer.querySelector('.has-items');
      var empty = drawer.querySelector('.no-items');
      if (container) container.style.display = hasItems ? '' : 'none';
      if (empty) empty.style.display = hasItems ? 'none' : '';
    });
  }

  function afterPaint(cart) {
    var lux = window.luxwatches;
    if (!lux) return;

    /* .btn-remove is bound directly (not delegated), so rebind after the swap.
       luxwatches uses .off().on() internally, so this will not double-bind. */
    try {
      if (typeof lux.removeItemDropdownCart === 'function') lux.removeItemDropdownCart(cart);
    } catch (e) {}

    try {
      if (typeof lux.checkNeedToConvertCurrency === 'function' &&
          lux.checkNeedToConvertCurrency() && window.Currency) {
        var active = document.querySelector('#currencies .active');
        window.Currency.convertAll(
          window.shop_currency,
          active ? active.getAttribute('data-currency') : window.shop_currency,
          '#dropdown-cart span.money',
          'money_format'
        );
      }
    } catch (e) {}

    /* Let apps / other scripts react to the re-render. */
    try {
      document.dispatchEvent(new CustomEvent('cart:drawer:updated', { detail: { cart: cart } }));
    } catch (e) {}
  }

  function renderFromServer(cart) {
    /* Collapse bursts (e.g. rapid +/- clicks) into the latest request. */
    pending = fetchDrawerMarkup()
      .then(function (markup) {
        paint(markup);
        afterPaint(cart);
      })
      .catch(function (err) {
        console.error('[cart-drawer-render]', err);
        /* Never leave the drawer stale: fall back to the old client render. */
        if (typeof originalUpdate === 'function') {
          try { originalUpdate.call(window.luxwatches, cart); } catch (e) {}
        }
      });

    return pending;
  }

  function install() {
    if (!window.luxwatches || typeof window.luxwatches.doUpdateDropdownCart !== 'function') {
      return false;
    }

    originalUpdate = window.luxwatches.doUpdateDropdownCart;

    /* All cart mutations (add, qty +/-, remove) funnel through this one method,
       so overriding it covers every path. */
    window.luxwatches.doUpdateDropdownCart = function (cart) {
      return renderFromServer(cart);
    };

    /* Public hook for any other script that needs a manual refresh. */
    window.luxwatches.refreshDropdownCart = function () {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return renderFromServer(cart); });
    };

    return true;
  }

  if (!install()) {
    /* luxwatches.min.js is injected via document.write + defer, so it may not be
       parsed yet. Poll briefly rather than racing it. */
    var tries = 0;
    var timer = setInterval(function () {
      if (install() || ++tries > 200) clearInterval(timer);
    }, 50);
  }
})();